const cmpSubNav = {
  component: null,

  init: function (element) {
    const dropdown = element.querySelector('.cmp-subnav__dropdown')
    const nav = element.querySelector('.cmp-subnav__nav')
    const links = element.querySelectorAll('.cmp-subnav__link')

    dropdown.addEventListener('click', (event) => {
      event.stopPropagation()

      dropdown.classList.toggle('open')
      nav.classList.toggle('vh')
    })

    links.forEach((link) => {
      if (link.classList.contains('active')) {
        dropdown.textContent = link.textContent
      }
    })
  }
}

export default cmpSubNav
